export default __webpack_public_path__ + "static/media/Ballroll_00313.c9efed87.png";